import { styled, Card, Typography, Box } from '../../../base';

export const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2.5),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
}));

export const StyledContentWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
});

export const StyledValueColumnWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginInlineEnd: theme.spacing(2),
    height: '100%',
}));

export const StyledValueContainer = styled(Typography)({
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: 1,
    textAlign: 'center',
});

export const StyledPercentContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',
});
